module.exports = __webpack_public_path__ + "static/img/addFunc.2d32a5c1.png";